export default {
  release: '18.8',
  date: 'January 2026',
  releasePostUrl: 'https://docs.gitlab.com/releases/18/gitlab-18-8-released/#this-months-notable-contributor-wesley-yarde',
  contributors: [
    {
      name: 'Wesley Yarde',
      gitlabUsername: 'WYarde',
    },
  ],
  writeUp: `This month's Notable Contributor is Wesley Yarde for building a foundational new feature that allows organizations to disable SSH keys for their enterprise users.

Wesley's contribution stands out for several reasons:

- **Security and compliance**: This feature enables organizations to enforce SSH key requirements and enhance security across their enterprise.
- **Foundational work**: With no existing implementation to follow, Wesley had to collaborate extensively with the GitLab team to define requirements and architecture from scratch.
- **First contribution**: Remarkably, this was Wesley's first contribution to GitLab—demonstrating exceptional ability to navigate a complex codebase and tackle a challenging feature.
- **Enables future development**: This work establishes the foundation for similar features like instance-level SSH key disabling and service account controls.

The implementation spanned multiple merge requests ([!205020](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/205020), [!210482](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/210482)) with thorough review cycles. Despite the complexity, Wesley demonstrated outstanding collaboration and patience throughout the process.

"It was a pleasure to collaborate with Wesley on this feature request! While both the contributor and reviewers may have felt that the review process was overwhelming, both sides showed understanding and superb collaboration to ensure the implementation is solid and complete." — [Bogdan Denkovych](https://gitlab.com/bdenkovych), who nominated Wesley for this recognition.

Congratulations Wesley, and thank you for this valuable contribution to GitLab!`,
};
